import { useState, useEffect, useCallback } from 'react';
import { motion } from 'framer-motion';
import { useIsMobile } from '@/hooks/use-mobile';
import MandalaWatermark from './MandalaWatermark';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { getCookieItem } from '@/utils/utils';

const ceremonies1 = "/images/ceremonies-1.jpg";
const ceremonies2 = "/images/Poojas1.jpg";

const defaultCategories = [
  {
    title: 'Ceremonies',
    url: '/hindi/bangalore/category/home-doshas',
    images: [ceremonies1, ceremonies2],
  },
  {
    title: 'Festival Poojas',
    url: '/hindi/bangalore/category/festival-pooja',
    images: [ceremonies1, ceremonies2],
  },
  { title: 'Health Issues', url: '/hindi/bangalore/pooja', images: [ceremonies1, ceremonies2] },
  { title: 'Money & Finance', url: '/hindi/bangalore/pooja', images: [ceremonies1, ceremonies2] },
];

const CategoryCard = ({ cat, index }) => {
  const [imgIndex, setImgIndex] = useState(0);
  const images = [cat.imageLink];

  useEffect(() => {
    if (images.length <= 1) return;
    const interval = setInterval(() => {
      setImgIndex((prev) => (prev + 1) % images.length);
    }, 3000 + index * 500);
    return () => clearInterval(interval);
  }, [images.length, index]);

  const router = useRouter();
  const handleClick = useCallback(() => {
    const location = getCookieItem("locationName") || 'bangalore';
    const language = getCookieItem("languageName") || 'hindi';
    console.log(location, language);
    if (cat.slug) {
      router.push(`/${language}/${location}/category/${cat.slug}`);
    }
  }, [cat.slug, router]);

  return (
    <motion.button
      onClick={handleClick}
      className="flex flex-col items-center w-full group cursor-pointer"
      initial={{ opacity: 0, y: 20, scale: 0.95 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      viewport={{ once: true, margin: '-30px' }}
      transition={{ duration: 0.4, delay: index * 0.06 }}
    >
      <div
        className="relative rounded-xl overflow-hidden w-full aspect-[3/4] border-2 border-primary/10 group-hover:border-primary/30 group-hover:shadow-lg transition-all duration-300">
        {images.map((img, i) => (
          <div
            key={i}
            className="absolute inset-0 transition-opacity duration-700 ease-in-out"
            style={{ opacity: imgIndex === i ? 1 : 0 }}
          >
            <Image
              src={img}
              alt={cat.title}
              fill
              className="object-cover group-hover:scale-105 transition-transform duration-500"
              sizes="(max-width: 768px) 30vw, 20vw"
            />
          </div>
        ))}
        {/* Text overlay */}
        <div
          className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent pt-10 pb-3 px-3">
          <h3 className="text-center text-sm md:text-base font-bold text-white drop-shadow-md">
            {cat.subCategoryName}
          </h3>
        </div>
      </div>
    </motion.button>
  );
};

const CategoriesSection = ({ categories: cmsCategories, categoriesData }) => {

  const isMobile = useIsMobile();
  const displayCategories = (cmsCategories?.length > 0 ? cmsCategories : defaultCategories);

  return (
    <section id="categories" className="py-6 md:py-10 bg-background">
      <div className="container">
        <div className="flex items-center justify-center gap-2 mb-2">
          <MandalaWatermark className="w-6 h-6 text-primary animate-spin"
                            style={{ animationDuration: '20s' } } />
          <h2 className="text-2xl md:text-4xl font-bold text-center">
            {categoriesData?.title?.split(categoriesData?.highlight)[0]} <span className="text-primary">{categoriesData?.highlight}</span> {categoriesData?.title?.split(categoriesData?.highlight)[1]}
          </h2>
          <MandalaWatermark className="w-6 h-6 text-primary animate-spin"
                            style={{ animationDuration: '20s' }} />
        </div>
        <p className="text-center text-muted-foreground text-sm md:text-base mb-4">
          {isMobile ? (categoriesData?.subtitleMobile || 'Tap') : (categoriesData?.subtitle || 'Click')} a category to explore pujas
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
          {displayCategories.map((cat, i) => (
            <CategoryCard key={cat.categoryName || i} cat={cat} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoriesSection;
